import { createUseStyles } from "react-jss";
import { apaTheme } from "../../constants/theme";

export const useStyles = () => {
  return createUseStyles({
    button: {
      "&.MuiButtonBase-root": {
        boxShadow: "none",
        color: "white",
        fontWeight: 400,
        padding: 12,
        borderRadius: 8,
        textTransform: "none",
        fontSize: 14,
        height: "56px",
      },
    },
    iconButton: {
      marginLeft: "2px",
      marginBottom: "-2px",
      fontSize: "none !important",
    },
    primary: {
      "&.MuiButtonBase-root": {
        backgroundColor: `${apaTheme.color.background.brand.default}`,
        color: "white",
        border: `1px solid ${apaTheme.color.border.brand.default}`,
        "&:hover": {
          backgroundColor: `${apaTheme.color.background.brand.hover}`,
        },
      },
      "&.Mui-disabled": {
        backgroundColor: `${apaTheme.color.background.brand.disabled} !important`,
        border: `1px solid ${apaTheme.color.background.brand.disabled} !important`,
        color: "white !important",
        cursor: "not-allowed",
        pointerEvents: "auto",
      },
      "& $iconColor": {
        color: "white",
        "&:hover": {
          color: "white",
        },
      },
    },
    secondary: {
      "&.MuiButtonBase-root": {
        backgroundColor: "#F2F2F2",
        color: apaTheme.color.text.default.secondary,
        border: `1px solid ${apaTheme.color.border.brand.secondary}`,
        "&:hover": {
          backgroundColor: "#E6E6E6",
          border: `1px solid ${apaTheme.color.border.brand.default}`,
        },
      },
      "&.Mui-disabled": {
        backgroundColor: `#F2F2F2 !important`,
        border: `1px solid #E6E6E6 !important`,
        color: "#606060 !important",
        cursor: "not-allowed",
        pointerEvents: "auto",
      },
      "& $iconColor": {
        color: "white",
        "&:hover": {
          color: "white",
        },
      },
    },
    tertiary: {
      "&.MuiButtonBase-root": {
        backgroundColor: "transparent",
        color: apaTheme.color.text.default.secondary,
        border: `1px solid #F2F2F2`,
        "&:hover": {
          backgroundColor: "#F2F2F2",
          border: `1px solid ${apaTheme.color.border.brand.default}`,
        },
      },
      "&.Mui-disabled": {
        backgroundColor: `transparent !important`,
        border: `1px solid #F2F2F2 !important`,
        color: "#606060 !important",
        cursor: "not-allowed",
        pointerEvents: "auto",
      },
      "& $iconColor": {
        color: "white",
        "&:hover": {
          color: "white",
        },
      },
    },
    destructive: {
      "&.MuiButtonBase-root": {
        backgroundColor: "#FCF5F5",
        color: "#CC3535",
        border: `1px solid #CC3535`,
        "&:hover": {
          backgroundColor: "#F5D7D7",
          border: `1px solid #A32A2A`,
          color: "#A32A2A",
        },
      },
      "&.Mui-disabled": {
        backgroundColor: `#FCF5F5 !important`,
        border: `1px solid #CC3535 !important`,
        color: "#CC3535 !important",
        cursor: "not-allowed",
        pointerEvents: "auto",
      },
      "& $iconColor": {
        color: "white",
        "&:hover": {
          color: "white",
        },
      },
    },
    text: {
      "&.MuiButtonBase-root": {
        backgroundColor: "transparent",
        color: apaTheme.color.text.brand.default,
        border: "1px solid transparent !important",
        "&:hover": {
          backgroundColor: "#F2F2F2",
          border: `1px solid ${apaTheme.color.border.brand.default}`,
        },
      },
      "&.Mui-disabled": {
        backgroundColor: `transparent !important`,
        border: "1px solid transparent !important",
        color: apaTheme.color.text.brand.default,
        cursor: "not-allowed",
        pointerEvents: "auto",
      },
      "& $iconColor": {
        color: "white",
        "&:hover": {
          color: "white",
        },
      },
    },
  })();
};
